import React from "react";
import classNames from "classnames";
import style from "../../css/old/Checkbox.module.css";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: React.ReactNode;
  click?: React.MouseEventHandler<HTMLLabelElement>;
  invalid?: boolean;
}

export default function Checkbox({ label, click, invalid, ...props }: Props) {
  return (
    <label
      className={classNames(style.checkbox, {
        [style.invalid]: invalid,
      })}
      onClick={click}
    >
      <input type="checkbox" {...props} />
      {label}
    </label>
  );
}
